import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';


@Injectable({
  providedIn: 'root',
})
export class CommissionsService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getDashBoardExtratoValues(
    initialDate: string,
    endDate: string,
    origin: string,
    application: string,
    personName: string,
    searchType: string,
  ): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('initialDate', initialDate);
    queryParams = queryParams.append('endDate', endDate);
    queryParams = queryParams.append('origin', origin)
    queryParams = queryParams.append('application', application)
    queryParams = queryParams.append('personName', personName)
    queryParams = queryParams.append('searchType', searchType)
    return this.http.get(this.url('/dashboard/extrato/montly'), {
      params: queryParams,
    });
  }

  getAccountTransactions(
    dateIni: string,
    dateEnd: string,
    page: number,
    pageSize: number,
    personName: string
  ): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('StartDate', dateIni);
    queryParams = queryParams.append('EndDate', dateEnd);
    queryParams = queryParams.append('Page', page);
    queryParams = queryParams.append('PageSize', pageSize);
    queryParams = queryParams.append('PersonName', personName)

    return this.http.get(this.url('/getAccountTransaction'), { params: queryParams, });
  }

  getCsvFile(startDate: Date, endDate: Date, type: string, status: string) {
    let csv = { startDate, endDate, type, status };

    return this.http.post<any>(this.url('/transactions/csv'), csv);
  }

  getLatestTransactions(): Observable<any> {
    return this.http.get(this.url('/transaction/latest'));
  }

  getEnum(): Promise<any> {
    const origin = this.authService.getOriginCurrency();
    let queryParams = new HttpParams();
    queryParams = queryParams.append('origin', origin);

    return firstValueFrom(
      this.http.get<any>(`${environment.apiUrl}/enum`, { params: queryParams })
    );
  }

  exportDataPdf(startDate: string, endDate: string){
    return this.http.post<any>(this.url('/reports/comissions'), { startDate: startDate, endDate: endDate });
  }

}
